import { UseFormRegister } from 'react-hook-form';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, TextField, Typography } from '@mui/material';
import { COLOR_WH, ReferralTip, ZERO_ADDRESS } from 'shared';
import { ArrowAccordion } from 'shared/ui/Icon';

import { BuyCoinsErrors, FormData } from '../../lib';

type AddReferralAccordionProps = {
  register: UseFormRegister<FormData>;
  onReferralAddressChange: (e: any) => void;
  errors: BuyCoinsErrors;
};

export const AddReferralAccordion = ({ register, onReferralAddressChange, errors }: AddReferralAccordionProps) => {
  return (
    <Accordion className="secondary">
      <AccordionSummary expandIcon={<ArrowAccordion />}>
        <Stack direction="row" spacing={1}>
          <Typography className="secondary">Enter referral address</Typography>
          <ReferralTip />
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack alignItems="center" spacing={1}>
          <TextField
            {...register('fatherAddress', { onChange: onReferralAddressChange })}
            InputLabelProps={{ shrink: true }}
            placeholder={ZERO_ADDRESS}
            color={errors.referral ? 'error' : 'primary'}
          />
          <Typography textAlign="center" className="secondary">
            <Box component="span" color={COLOR_WH}>
              Earn 10%
            </Box>{' '}
            instantly in USDT/USDC off all purchases made by your referrals
          </Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
